var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6496 12.6963L9.33126 8.08016C9.11447 7.95963 8.8501 7.97625 8.64522 8.12172L2.28449 12.7379C2.04656 12.9111 1.94345 13.2256 2.03069 13.5151C2.11529 13.8019 2.37173 14 2.65989 14H17.339C17.6417 14 17.9074 13.7839 17.9801 13.4735C18.0541 13.1646 17.9167 12.8446 17.6496 12.6963Z",
    fill: "#3F4D55"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.972 0.450893C14.889 0.182412 14.6462 0 14.3707 0H2.74321C2.44884 0 2.19347 0.209389 2.12932 0.503562L0.0146555 10.219C-0.0406956 10.4772 0.0637166 10.7431 0.277573 10.8908C0.383243 10.964 0.506525 11 0.628549 11C0.754347 11 0.878887 10.9627 0.987073 10.8857L14.728 1.17027C14.9557 1.01098 15.0525 0.719374 14.972 0.450893Z",
    fill: "#3F4D55"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3636 2.45979C18.3241 2.26836 18.198 2.11217 18.0279 2.04053C17.8568 1.96889 17.6648 1.99355 17.5156 2.10395L12.2358 6.01704C12.0779 6.13448 11.989 6.3306 12.0011 6.53377C12.0121 6.73929 12.1229 6.92249 12.2918 7.01762L19.194 10.9307C19.2752 10.9765 19.363 11 19.4507 11C19.5681 11 19.6855 10.9601 19.7831 10.879C19.9531 10.7405 20.0332 10.5091 19.9872 10.2848L18.3636 2.45979Z",
    fill: "#3F4D55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgData);
export default __webpack_public_path__ + "static/media/data.36d194913dad055b58cd5b942966584f.svg";
export { ForwardRef as ReactComponent };